import Vue from "vue";

Vue.directive("clickoutside", {
  bind: function(el, binding) {
    el.eventHandler = event => {
      if (!el.contains(event.target) && el !== event.target) {
        binding.value(event);
      }
    };
    document.addEventListener("click", el.eventHandler);
  },
  unbind: function(el) {
    document.removeEventListener("click", el.eventHandler);
  }
});
